import React from 'react';
import { useStyles } from './MetricsStyle';
import { Line } from 'react-chartjs-2';
import { Chart as ChartJS, LineElement, PointElement, LinearScale, Title, CategoryScale, Filler } from 'chart.js';
ChartJS.register(LineElement, PointElement, LinearScale, CategoryScale, Filler, Title);
export default function Metrics() {
    const styles = useStyles();
    const [index, setIndex] = React.useState(0);
    let options = {
        maintainAspectRatio: false,
        scales: {
            y: {
                max: 100,
                min: 0,
                ticks: {
                    stepSize: 25,
                }
            },
        }
    };
    const data = {
        labels: ['17:00', '17:00', '17:00', '17:00', '17:00', '17:00', '17:00', '17:00', '17:00', '17:00', '17:00', '17:00', '17:00', '17:00', '17:00', '17:00'],
        datasets: [
            {
                label: 'Videos',
                backgroundColor: '#CFA639',
                data: [5, 10, 5, 25, 14, 10, 4, 6, 25, 12, 5, 5, 15, 20, 25, 10],
                fill: 'origin',
                showLine: false,
                tension: 0.5,
                pointStyle: 'dash',
            },
            {
                label: 'description',
                backgroundColor: '#13B782',
                data: [10, 20, 12, 35, 24, 20, 8, 14, 35, 22, 10, 15, 25, 30, 35, 20],
                fill: 'origin',
                showLine: false,
                tension: 0.5,
                pointStyle: 'dash',
            },
            {
                label: 'description',
                backgroundColor: '#824ED2',
                data: [20, 30, 18, 45, 32, 35, 15, 18, 45, 32, 15, 25, 35, 40, 45, 30],
                fill: 'origin',
                showLine: false,
                tension: 0.5,
                pointStyle: 'dash'
            }
        ],
    }
    return (
        <div>
            <div className={styles.tabsAndBtnRow}>
                <div className={styles.tabsRow}>
                    {
                        ['1H', '1D', '1W', '1M', '1Y'].map((item, i) => {
                            return (
                                <div onClick={() => setIndex(i)} className={index == i ? styles.selectedTab : styles.notSelectedTab}>
                                    <p>{item}</p>
                                </div>
                            )
                        })
                    }
                </div>
                <button className={styles.integrationBtn}>Enable Metrics integration</button>
            </div>
            <p className={styles.graphTitle}>CPU usage %</p>
            <div className={styles.graphLinesClrsIndicatorsRow}>
                <div className={styles.clrAndNameRow}>
                    <div className={styles.blueClrContainer} />
                    <p className={styles.clrTitle}>Kafka-17df678-1</p>
                </div>
                <div className={styles.clrAndNameRow}>
                    <div className={styles.greenClrContainer} />
                    <p className={styles.clrTitle}>Kafka-17df678-1</p>
                </div>
                <div className={styles.clrAndNameRow}>
                    <div className={styles.orangeClrContainer} />
                    <p className={styles.clrTitle}>Kafka-17df678-1</p>
                </div>
            </div>
            <div className={styles.graphContainer}>
                <Line
                    data={data}
                    options={options}
                />
            </div>
            <p className={styles.graphTitle}>Disk space usage%</p>
            <div className={styles.graphLinesClrsIndicatorsRow}>
                <div className={styles.clrAndNameRow}>
                    <div className={styles.blueClrContainer} />
                    <p className={styles.clrTitle}>Kafka-17df678-1</p>
                </div>
                <div className={styles.clrAndNameRow}>
                    <div className={styles.greenClrContainer} />
                    <p className={styles.clrTitle}>Kafka-17df678-1</p>
                </div>
                <div className={styles.clrAndNameRow}>
                    <div className={styles.orangeClrContainer} />
                    <p className={styles.clrTitle}>Kafka-17df678-1</p>
                </div>
            </div>
            <div className={styles.graphContainer}>
                <Line
                    data={data}
                    options={options}
                />
            </div>
            <p className={styles.graphTitle}>Disk iops (reads)</p>
            <div className={styles.graphLinesClrsIndicatorsRow}>
                <div className={styles.clrAndNameRow}>
                    <div className={styles.blueClrContainer} />
                    <p className={styles.clrTitle}>Kafka-17df678-1</p>
                </div>
                <div className={styles.clrAndNameRow}>
                    <div className={styles.greenClrContainer} />
                    <p className={styles.clrTitle}>Kafka-17df678-1</p>
                </div>
                <div className={styles.clrAndNameRow}>
                    <div className={styles.orangeClrContainer} />
                    <p className={styles.clrTitle}>Kafka-17df678-1</p>
                </div>
            </div>
            <div className={styles.graphContainer}>
                <Line
                    data={data}
                    options={options}
                />
            </div>

        </div>
    )
}
